import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import EditTwitterConfigContext from 'contexts/EditTwitterConfigContext';
import TwitterConfigForm from 'forms/TwitterConfigForm';

export default (): JSX.Element => {
  const history = useHistory();
  const { t } = useTranslation();
  const { selectedTwitterConfig } = React.useContext(EditTwitterConfigContext);
  if (!selectedTwitterConfig) return <></>;
  return (
    <div>
      <TwitterConfigForm twitterConfig={selectedTwitterConfig} />
      <Box display="flex" justifyContent="center" width={1}>
        <Button className="btn-50" variant="contained" color="secondary" onClick={() => history.go(-1)}>
          {t('go-back')}
        </Button>
      </Box>
    </div>
  );
};
